export const SET_DEFAULT_CITY = 'SET_DEFAULT_CITY';
export const SET_SEARCH_CITY = 'SET_SEARCH_CITY';
export const SET_FETCH_ERROR = 'SET_FETCH_ERROR';